import { useCallback, useEffect, useState } from "react";
import qs from "qs";
import { useMemo } from "react";
import { useTranslation, useI18next } from "gatsby-plugin-react-i18next";
import { KOMODO } from "store/constants/hotel"; // Import KOMODO constant

const useBookingFormLink = ({
  startDate,
  endDate,
  adults,
  infants,
  rooms,
  children,
  hotelCode = "",
  roomCode = "",
  location,
  bookingCode = "",
  tags = [],
  group = "",
  packageCode = "",
}) => {
  const [link, setLink] = useState("");
  const [validationDate, setValidationDate] = useState(false);
  const [validationRoomGuest, setValidationRoomGuest] = useState(false);
  const { t } = useTranslation();
  const { language } = useI18next();

  const handleInvalidSearch = useCallback(
    (e) => {
      const validLink = link?.trim().length > 0;

      if (!validLink) {
        e.preventDefault();
      }
    },
    [adults, children, infants, endDate, link, rooms, startDate, hotelCode, tags]
  );

  useEffect(() => {
    setValidationDate(
      !startDate?.trim() || !endDate?.trim() ? t("validation.date") : null
    );

    setValidationRoomGuest(
      !(adults > 0) || !(rooms > 0) ? t("validation.roomAndGuest") : null
    );

    const isFormParamsValid = [validationDate, validationRoomGuest].every(
      (p) => !p
    );

    if (isFormParamsValid) {
      setLink(
        `${process.env.GATSBY_BOOKING_ENGINE_URL}${language ? `${language}` : ""
        }/rooms?${qs.stringify({
          location_code: location ? `${location[0]?.toUpperCase()}${location.slice(1).toLowerCase()}` : "",
          date_from: startDate,
          date_to: endDate,
          adults,
          ...(location?.toUpperCase() === KOMODO?.toUpperCase() && { infants }), // Only include infants if location is KOMODO
          children,
          rooms: rooms,
          property_main:
            hotelCode && hotelCode.trim() !== "" ? hotelCode : undefined,
          room_code: roomCode,
          booking_code: bookingCode.toUpperCase(),
          tags,
          group,
          package_code: packageCode,
        })}`
      );
    } else {
      setLink("");
    }
  }, [
    startDate,
    endDate,
    adults,
    infants,
    children,
    rooms,
    hotelCode,
    validationDate,
    validationRoomGuest,
    language,
    bookingCode,
    tags,
    packageCode,
    location, // Add location to the dependency array
  ]);

  return useMemo(
    () => ({
      link,
      handleInvalidSearch,
      validationDate,
      validationRoomGuest,
    }),
    [link, handleInvalidSearch, validationDate, validationRoomGuest]
  );
};

export default useBookingFormLink;
